import { Observable } from 'rxjs';
import { AuthUser } from '../models/auth-user.model';

/**
 * Interface que define os métodos obrigatórios para autenticação
 * Cada aplicação Chronos deve implementar esta interface
 */
export abstract class IAuthService {
  /**
   * Realiza o login do usuário
   * @param usuario Email ou username
   * @param senha Senha do usuário
   * @returns Promise com void em caso de sucesso
   */
  abstract login(usuario: string, senha: string): Promise<void>;

  /**
   * Realiza o logout do usuário
   * @returns Promise com void
   */
  abstract logout(): Promise<void>;

  /**
   * Solicita o reset de senha enviando email
   * @param email Email do usuário
   * @returns Observable com void
   */
  abstract solicitarRecuperarSenha(email: string): Observable<void>;

  /**
   * Confirma o reset de senha com o token recebido
   * @param email Email do usuário
   * @param novaSenha Nova senha
   * @param token Token de confirmação
   * @returns Observable com void
   */
  abstract resetarSenha(
    email: string,
    novaSenha: string,
    token: string
  ): Observable<void>;

  /**
   * Verifica se o token de acesso está válido
   * @returns true se inválido, false se válido
   */
  abstract isAccessTokenInvalido(): boolean;

  /**
   * Obtém novo access token usando refresh token
   * @returns Promise com void ou null
   */
  abstract obterNovoAccessToken(): Promise<void | null>;

  /**
   * Obtém os dados do usuário autenticado
   * @returns Dados do usuário ou null
   */
  abstract getCurrentUser(): AuthUser | null;

  /**
   * Verifica se o usuário tem determinada permissão
   * @param permissions Lista de permissões a verificar
   * @returns true se possui alguma das permissões
   */
  abstract havePermission(...permissions: string[]): boolean;
}
